(function($){
  'use strict';

  if(!$.tangible){
    $.tangible = new Object();
  };

  $.tangible.bookingInfo = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.init = function(){

      base.$mainForm = $('.c-booking-info');
      base.$inputs = $('.c-booking-info input, .c-booking-info select');
      base.$inputsArray = $('.c-booking-info input').toArray();
      base.$buttonEdit = $('.c-booking-info .js-booking-info-btn-edit');
      base.$buttonConfirm = $('.c-booking-info .js-booking-info-btn-confirm');
      base.$overlay = $('.o-spotlight__element');
      base.$closeOverlayBtn = $('.js-close-overlay');

      base.addsReadonly();
      
      base.$buttonEdit.click(function(e){
        e.preventDefault();
        base.removesReadonly();
        base.setFocusOnFirstInput();
        base.changeButton( $(this) );
        base.addsOverlay();
      });

      base.$closeOverlayBtn.click(function(e){
        e.preventDefault();
        base.removesOverlay( $(this) );
        base.addsReadonly();
        base.$buttonConfirm.hide();
        base.$buttonEdit.show();
      });

    };

    // Adds overlay
    base.addsOverlay = function() {
      base.$overlay.addClass('o-spotlight__element--overlay');
      base.$overlay.parent('.o-spotlight').addClass('is-active');
      base.$closeOverlayBtn.show();
    }

    // Removes overlay
    base.removesOverlay = function(elem) {
      base.$overlay.removeClass('o-spotlight__element--overlay');
      base.$overlay.closest('.o-spotlight').removeClass('is-active');
      elem.hide();
    }

    // Adds readonly
    base.addsReadonly = function() {
      base.$inputs.prop('readonly', true);
      base.$inputs.prop('disabled', true);
      base.$inputs.parent().addClass("is-readonly");
    }

    // Removes readonly
    base.removesReadonly = function() {
      base.$inputs.prop('readonly', false);
      base.$inputs.prop('disabled', false);
      base.$inputs.parent().removeClass("is-readonly");
    }

    // Set focus on first input
    base.setFocusOnFirstInput = function() {
      base.$inputsArray[0].focus();
    }

    base.changeButton = function(el) {
      el.hide();
      base.$buttonConfirm.show();
    }

    base.init();

  };

  $.fn.tangible_bookingInfo = function(options){
    return this.each(function(){
      (new $.tangible.bookingInfo(this, options));
    });
  };

})(jQuery);

